import React, { useEffect, useRef, useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import io from "socket.io-client";
import axios from "axios";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "./assets/css/responsive.scss";
import "./assets/css/styles.scss";
import WheelContent from "./Wheel/WheelContent";
import { adminBaseURL, baseURL, key } from "./config";
import GameStatusOverlay from "./GameStatusOverlay";

const queryParams = new URLSearchParams(window.location.search);
const userId = queryParams.get("id");
const localUiPreview =
  process.env.NODE_ENV === "development" && queryParams.get("preview") === "1";
axios.defaults.headers.common["key"] = key;

const coinNumbe = [100, 200, 300, 400, 500];
function App() {
  const socketRef = useRef();
  const [liveSocket, setLiveSocket] = useState(null);
  const [userData, setUserData] = useState();
  const [gameCoin, setGameCoin] = useState(coinNumbe);
  const [control, setControl] = useState(
    localUiPreview
      ? { status: "active", enabled: true }
      : { status: "maintenance", enabled: false }
  );

    // STREAMFY_SOCKET_RECOVERY
    useEffect(() => {
      if (!userId) return undefined;

      const socket = io.connect(baseURL, {
        transports: ["websocket", "polling"],
        query: { globalRoom: userId },
        reconnection: true,
        reconnectionAttempts: Infinity,
        reconnectionDelay: 1000,
        reconnectionDelayMax: 5000,
        randomizationFactor: 0.3,
        timeout: 10000,
      });

      socketRef.current = socket;
      setLiveSocket(socket);

      let lastSocketActivity = Date.now();

      const markSocketActivity = () => {
        lastSocketActivity = Date.now();
      };

      const receiveStart = (data) => {
        console.log("data-->", data);
        setUserData(data);
      };

      const initializeSocketSession = () => {
        lastSocketActivity = Date.now();
        socket.emit("startGame", {});
        socket.emit("controlStatusRequest");
      };

      const handleDisconnect = () => {
        setControl({
          status: "maintenance",
          enabled: false,
        });
      };

      socket.on("start", receiveStart);
      socket.on("connect", initializeSocketSession);
      socket.on("disconnect", handleDisconnect);
      socket.onAny(markSocketActivity);

      if (socket.connected) {
        initializeSocketSession();
      }

      const watchdog = window.setInterval(() => {
        if (!socket.connected) {
          socket.connect();
        } else if (
          Date.now() - lastSocketActivity > 8000
        ) {
          initializeSocketSession();
        }
      }, 4000);

      return () => {
        window.clearInterval(watchdog);
        socket.off("start", receiveStart);
        socket.off("connect", initializeSocketSession);
        socket.off("disconnect", handleDisconnect);
        socket.offAny(markSocketActivity);
        socket.disconnect();
        socketRef.current = undefined;
        setLiveSocket(null);
      };
    }, [userId]);

  useEffect(() => {
    socketRef.current?.on("user", (user) => {
      if (user && Object?.values(user)?.length > 0) {
        console.log("user-->", user);
        setUserData(user);
      }
    });
  }, [socketRef?.current]);

  useEffect(() => {
    const socket = liveSocket;
    if (!socket) return;
    const receive = (value) => setControl(value);
    const rejected = (value) => toast(value?.message || `Bet rejected: ${value?.reason || "game unavailable"}`);
    const request = () => socket.emit("controlStatusRequest");
    socket.on("gameStatus", receive);
    socket.on("betRejected", rejected);
    request();
    const timer = setInterval(request, 3000);
    return () => {
      clearInterval(timer);
      socket.off("gameStatus", receive);
      socket.off("betRejected", rejected);
    };
  }, [liveSocket]);

  useEffect(() => {
    axios
      .get(`${adminBaseURL}api/admin/setting/retrieveGameSettings`)
      .then((res) => {
        if (res?.data?.data?.gameCoin) {
          setGameCoin(res?.data?.data?.gameCoin);
        }
      })
      .catch((err) => console.log(err));
  }, []);

  return (
    <div className="game-page">
      <GameStatusOverlay control={control} />
      <WheelContent userData={userData} socket={liveSocket} gameCoin={gameCoin} />
      <ToastContainer />
    </div>
  );
}

export default App;
